import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Parser from 'html-react-parser';
import l from '../../../../lang';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { canViewAndCopyApiKeys } from '../../../../store/payment-integration/roles';
import InputSecret from '../../../common/input-secret';
import {
  segmentIntegrationsKeysCopyApiKey,
  segmentIntegrationsKeysCopySecretKey,
  segmentIntegrationsKeysCopySmartFieldsApiKey,
} from '../../../../utils/analytics';
import LightbulbIcon from '../../../../assets/icons/lightbulb.svg?url';

const ApiKeysSection = () => {
  const { apiKey, secretKey, smartFieldsApiKey, getIntegrationKeys } = usePaymentIntegration();
  const { auth } = useSelector(state => state);
  const canViewKeys = canViewAndCopyApiKeys(auth?.roles);

  useEffect(() => {
    if (apiKey.length === 0) {
      getIntegrationKeys();
    }
  }, []);

  return (
    <div className="api_keys_section">
      <div className="api_keys_section__header">
        <h2 className="api_keys_section__title">{l('paymentIntegration.api.page.keys.headline')}</h2>
        <p className="api_keys_section__description">{Parser(l('paymentIntegration.api.page.keys.description'))}</p>
      </div>
      <div className="api_keys_section__body">
        <div className="api_keys_section__fields">
          <div className="api_keys_section__field">
            <InputSecret
              text={apiKey}
              label={l('paymentIntegration.api.page.keys.apiKey')}
              onCopy={() => segmentIntegrationsKeysCopyApiKey()}
              disabled={!canViewKeys}
            />
          </div>
          <div className="api_keys_section__field">
            <InputSecret
              text={secretKey}
              label={l('paymentIntegration.api.page.keys.secretKey')}
              onCopy={() => segmentIntegrationsKeysCopySecretKey()}
              disabled={!canViewKeys}
            />
          </div>
          <div className="api_keys_section__field">
            <InputSecret
              text={smartFieldsApiKey}
              label={l('paymentIntegration.api.page.keys.smartFieldsApiKey')}
              onCopy={() => segmentIntegrationsKeysCopySmartFieldsApiKey()}
              disabled={!canViewKeys}
            />
          </div>
        </div>
        <div className="api_keys_section__tip">
          <img src={LightbulbIcon} alt="" aria-hidden />
          <span>{l('paymentIntegration.api.page.keys.tip')}</span>
        </div>
      </div>
    </div>
  );
};

export default ApiKeysSection;
